import { useCanOpenStep, useExperience } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Button, Divider, Text } from '@cascade/ui-library';
import { useNavigate } from 'react-router-dom';
import classes from './StepNavigation.module.scss';
import { getExperienceSummaryPath } from '#config/index.ts';

export const StepNavigation = () => {
  const { translate, translateError } = useI18n();
  const {
    experienceId,
    previousStepId,
    nextStepId,
    isSideStep,
    isLastStep,
    stepError,
    saveAnswersError,
    openStep,
    saveAnswers,
  } = useExperience();

  const canOpenStep = useCanOpenStep();
  const navigate = useNavigate();

  const canMoveForward = canOpenStep && !stepError;
  const summaryPath = getExperienceSummaryPath(experienceId);
  const errorMessage = saveAnswersError
    ? translateError(saveAnswersError)
    : undefined;

  const openPreviousStep = () => {
    if (!previousStepId) {
      return;
    }

    openStep(previousStepId);
  };

  const openNextStep = () => {
    if (!nextStepId) {
      return;
    }

    openStep(nextStepId);
  };

  const completeExperience = () => {
    saveAnswers()
      .then(() => navigate(summaryPath))
      .catch(() => undefined);
  };

  return (
    <div className={classes['step-navigation']}>
      <Divider />
      {errorMessage ? (
        <Text
          type='body-2'
          color='text-danger'
          role='alert'
          content={errorMessage}
        />
      ) : null}
      <div className={classes.actions}>
        {previousStepId ? (
          <Button
            variant={isSideStep ? 'primary' : 'secondary'}
            iconType='arrow-left'
            label={translate('experience.back')}
            disabled={!canOpenStep}
            onClick={openPreviousStep}
          />
        ) : null}
        <div className={classes.forward}>
          {nextStepId ? (
            <Button
              iconType='arrow-right'
              iconPlacement='right'
              label={translate('experience.next')}
              disabled={!canMoveForward}
              onClick={openNextStep}
            />
          ) : null}
          {isLastStep ? (
            <Button
              iconType='check'
              label={translate('experience.complete')}
              disabled={!canMoveForward}
              onClick={completeExperience}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};
